import styled from 'styled-components';

const OFFSET_BY_DIRECTION = {
  left: 'translate3d(-52px, 0, 0)',
  right: 'translate3d(52px, 0, 0)',
  up: 'translate3d(0, 46px, 0)',
};

export type RevealDirection = keyof typeof OFFSET_BY_DIRECTION;

export const Wrapper = styled.div<{
  direction: RevealDirection;
  revealed: boolean;
}>`
  opacity: ${props => (props.revealed ? 1 : 0)};
  transform: ${props =>
    props.revealed
      ? 'translate3d(0, 0, 0)'
      : OFFSET_BY_DIRECTION[props.direction]};
  transition: opacity 0.7s cubic-bezier(0.22, 0.7, 0.25, 1),
    transform 0.85s cubic-bezier(0.22, 0.7, 0.25, 1);

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
    transition: none;
  }
`;
